// Uses browser media query to determine if this is a mobile (sized) browser
Jelly.Interface.Is_Mobile = function() {	
	return ($('body > #Is_Mobile').css("visibility") == "visible");
};